/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keen_Actual_Gibbon_SparkInputs */

const fr_keen_actual_gibbon_spark = /** @type {(inputs: Keen_Actual_Gibbon_SparkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop-in`)
};

/**

* @param {Keen_Actual_Gibbon_SparkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const keen_actual_gibbon_spark = /** @type {((inputs?: Keen_Actual_Gibbon_SparkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Actual_Gibbon_SparkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_keen_actual_gibbon_spark(inputs)
});